import { ReactNode } from 'react'

import { useSafetyTranslation } from 'cng-common/features/translations/hooks'

import { IPlanReviewTranslation } from '../config/translations'

interface IPlanReviewTextProps {
  text: IPlanReviewTranslation
  replace?: Record<string, ReactNode>
}

const replaceTextTokens = (value: string, replace: Record<string, ReactNode>) => {
  const tokens = value.split(/(\{[^{}]+\})/g)

  return tokens.map((token, index) => {
    const replacement = replace[token.slice(1, -1)]

    return replacement === undefined ? token : <span key={`${token}-${index}`}>{replacement}</span>
  })
}

export const PlanReviewText = ({ text, replace = {} }: IPlanReviewTextProps) => {
  const t = useSafetyTranslation()
  const value = t(text.key, { defaultValue: text.fallback })

  return <>{replaceTextTokens(value, replace)}</>
}
